<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:22:34
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-02 17:42:32
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="home-box">
    <div class="home-items home-items--col">
      <Entrance />
      <Assistant />
    </div>
    <div class="home-items home-items--fill">
      <Backlog />
      <div class="home-bottom-row">
        <Rules />
        <Journalism />
      </div>
    </div>
  </div>
</template>

<script>
import Entrance from './modules/Entrance'
import Rules from './modules/Rules'
import Recruit from './modules/Recruit'
import Backlog from './modules/Backlog'
import Inform from './modules/Inform'
import Notice from './modules/Notice'
import Journalism from './modules/Journalism'
import Assistant from './modules/Assistant'
import { session } from '@/libs/location'
export default {
  name: 'home',
  components: { Entrance, Rules, Recruit, Backlog, Inform, Notice, Journalism, Assistant },
  data () {
    return {
      avatorUrlInit: require('../../assets/images/avator.png')
    }
  },
  computed: {
    userInfo: () => JSON.parse(session.getItem('userInfo')) || {}
  },
  created () { },
  mounted () {
  },
  methods: {}
}
</script>

<style  lang="less">
@import url('./index.modules.less');
</style>
